<template>
    <b-modal id="modal-voucher" hide-footer centered  @hidden="hide">
        <template slot="modal-header">
            <h1 class="modal-title">{{ $t('modal_voucher.title') }}</h1>
            <div class="close" @click="$bvModal.hide('modal-voucher')"></div>
        </template>
        <div class="d-block text-center">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-danger pb-4 text-center text-uppercase small w-100" v-if="isInvalid">
                            {{ errorMessage }}
                        </div>

                        <form class="checkin-form w-100">
                            <div class="form-group w-100">
                                <input maxlength="20"
                                       type="text"
                                       v-model="code"
                                       @focus="isInvalid = false"
                                       class="checkin-form-picacode form-control"
                                       :placeholder="$t('modal_voucher.input_code_placeholder')">
                            </div>
                            <b-button variant="primary" block @click="redeemVoucher">
                                {{ $t('modal_voucher.btn_apply') }}
                            </b-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>


<script>
    import VoucherService from "@/services/Voucher"

    export default {
        props: [ 'checkinId' ],

        data() {
            return {
                code: '',
                isInvalid: false,
                errorMessage: ''
            }
        },

        methods: {
            redeemVoucher() {
                VoucherService.redeemVoucher(this.code, this.checkinId)
                    .then(() => {
                        this.hide()
                        setTimeout(() => this.$bvToast.toast(this.$t('modal_voucher.valid_voucher_feedback')), 200 )
                        this.$emit('voucher-redeemed')

                    })
                    .catch(error => {
                        if (error.response.status === 400 && error.response.data.code === 'voucher_already_used') {
                            this.errorMessage = this.$t('modal_voucher.already_used')
                        } else {
                            this.errorMessage = this.$t('modal_voucher.invalid_code')
                        }
                        this.isInvalid = true
                    })
            },

            hide() {
                this.code = ''
                this.$bvModal.hide('modal-voucher')
            }
        }
    }
</script>
